/**
 * @param {import('@/types/api').Appointment} left
 * @param {import('@/types/api').Appointment} right
 */
function appointmentsOverlap(left, right) {
  const leftStart = new Date(left.starts_at).getTime()
  const leftEnd = new Date(left.ends_at).getTime()
  const rightStart = new Date(right.starts_at).getTime()
  const rightEnd = new Date(right.ends_at).getTime()

  return leftStart < rightEnd && rightStart < leftEnd
}

/**
 * @param {import('@/types/api').Appointment[]} appointments
 * @returns {import('@/types/api').Appointment[][]}
 */
export function clusterOverlappingAppointments(appointments) {
  const sorted = [...appointments].sort(
    (left, right) => left.starts_at.localeCompare(right.starts_at),
  )

  /** @type {import('@/types/api').Appointment[][]} */
  const clusters = []
  let current = []
  let clusterEnd = 0

  for (const appointment of sorted) {
    const start = new Date(appointment.starts_at).getTime()
    const end = new Date(appointment.ends_at).getTime()

    if (current.length === 0 || start < clusterEnd) {
      current.push(appointment)
      clusterEnd = Math.max(clusterEnd, end)
      continue
    }

    clusters.push(current)
    current = [appointment]
    clusterEnd = end
  }

  if (current.length > 0) {
    clusters.push(current)
  }

  return clusters
}

/**
 * Side-by-side lane layout for overlapping bookings in one column.
 * @param {import('@/types/api').Appointment[]} appointments
 * @returns {Map<number, { column: number, totalColumns: number }>}
 */
export function layoutAppointmentLanes(appointments) {
  /** @type {Map<number, { column: number, totalColumns: number }>} */
  const layout = new Map()

  for (const cluster of clusterOverlappingAppointments(appointments)) {
    /** @type {import('@/types/api').Appointment[][]} */
    const columns = []

    for (const appointment of cluster) {
      let columnIndex = columns.findIndex(
        (column) => !column.some((existing) => appointmentsOverlap(existing, appointment)),
      )

      if (columnIndex === -1) {
        columnIndex = columns.length
        columns.push([])
      }

      columns[columnIndex].push(appointment)
    }

    const totalColumns = columns.length

    for (let columnIndex = 0; columnIndex < columns.length; columnIndex += 1) {
      for (const appointment of columns[columnIndex]) {
        layout.set(appointment.id, { column: columnIndex, totalColumns })
      }
    }
  }

  return layout
}

/**
 * @param {string} status
 */
export function canRescheduleAppointment(status) {
  return !['cancelled', 'no_show', 'completed'].includes(status)
}
